<!--
 * @Author: Daokai Huo
 * @Date: 2021-09-24 11:29:20
 * @LastEditTime: 2021-10-25 15:46:39
 * @Description: input组件
-->
<template>
  <el-input
    v-model="model"
    v-bind="$props"
    @blur="handleBlur"
    @focus="handleFocus"
    @input="handleChange"
    @clear="handleClear"
    class="ion-input"
    :showWordLimit="showWordLimit"
    :class="$slots.prepend && isFocus && 'focus-prepend'">
    <!-- 输入框前面增加内容 -->
    <template slot="prepend">
      <slot name="prepend"></slot>
    </template>
    <!-- 输入框后面增加内容 -->
    <template slot="append">
      <slot name="append"></slot>
    </template>
  </el-input>
</template>
<script>
  import xss from './xss';

  export default {
    name: 'IonInput',
    props: {
      // 类型 text，password，textarea等
      type: {
        type: String,
        default: 'text',
      },
      // 绑定值
      value: [String, Number],
      // 最大输入长度
      maxlength: [Number, String],
      // 最小输入长度
      minlength: [Number, String],
      // 输入框占位文本
      placeholder: {
        type: String,
        default: '请输入',
      },
      // 是否有清除按钮
      clearable: {
        type: Boolean,
        default: false,
      },
      // input禁用
      disabled: {
        type: Boolean,
        default: false,
      },
      // 是否只读
      readonly: {
        type: Boolean,
        default: false,
      },
      // 自动获取焦点
      autofocus: {
        type: Boolean,
        default: false,
      },
      // 输入框关联的label文字
      label: String,
      // 设置文本域行数，只对 type="textarea" 有效,
      rows: Number,
      // 设置文本域最小最大行数，只对 type="textarea" 有效，可传入对象，如，{ minRows: 2, maxRows: 6 }
      autosize: {
        type: [Boolean, Object],
        default: false,
      },
      // 是否显示切换密码图标
      showPassword: {
        type: Boolean,
        default: false,
      },
      // 输入时是否触发表单校验
      validateEvent: {
        type: Boolean,
        default: true,
      },
      showWordLimit: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isFocus: false,
      };
    },
    computed: {
      model: {
        get() {
          return this.value;
        },
        set(val) {
          // 根据客户需求，文本域不需要去除空格和换行
          if (this.type !== 'textarea') {
            this.$emit('input', xss.process(val.trim()));
          } else {
            this.$emit('input', val);
          }
        },
      },
    },
    methods: {
      /**
       * 在 Input 失去焦点时触发
       */
      handleBlur(evt) {
        this.isFocus = false;
        this.$emit('blur', evt);
      },
      /**
       * 在 Input 获得焦点时触发
       */
      handleFocus(evt) {
        this.isFocus = true;
        this.$emit('focus', evt);
      },
      /**
       * 在 Input 值改变时触发
       */
      handleChange(evt) {
        this.$emit('change', evt);
      },
      /**
       * 在点击由 clearable 属性生成的清空按钮时触发
       */
      handleClear() {
        this.$emit('clear');
      },
    },
  };
</script>
<style lang="scss">
  @import './index.scss';
</style>
